import { render } from "./DrugstoresSuppliersLocalDataList.vue?vue&type=template&id=9cf4f0d4&scoped=true"
import script from "./DrugstoresSuppliersLocalDataList.vue?vue&type=script&lang=js"
export * from "./DrugstoresSuppliersLocalDataList.vue?vue&type=script&lang=js"

import "./DrugstoresSuppliersLocalDataList.vue?vue&type=style&index=0&id=9cf4f0d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cf4f0d4"]])

export default __exports__